export const paymentsEnabled = true;
export const onlyShowMonthlyPlanInPayments = false;
// this variable will toggle whether verification pages are going to be shown or not, if this is false then there will not be 2fa and not even email pages will be verified. in other to "disable" 2fa i think that there should be a backend toggle as that is functionality from there
export const showVerificationPages = false;
export const secondsToWaitForSendingNewCode = 60;

// 31 days duration in seconds
// export const secondsRangeBetweenPhoneVerificationPrompts = 30; // for testing
export const secondsRangeBetweenPhoneVerificationPrompts = 31 * 24 * 60 * 60;
